import { forwardRef, type Ref, type SVGProps } from "react";
const IconMenuFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 18H6a2 2 0 0 1 0-4h20a2 2 0 0 1 0 4m0-8H6a2 2 0 0 1 0-4h20a2 2 0 0 1 0 4m0 16H6a2 2 0 0 1 0-4h20a2 2 0 0 1 0 4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMenuFilledSVG);
ForwardRef.displayName = "IconMenuFilled";
export { ForwardRef as IconMenuFilled };
